import React, { lazy } from "react";
import { Route, Redirect } from "react-router-dom";
import ForgotPassword from "./components/forgotPassword";
import ConfirmForgotPassword from "./components/confirmForgotPassword";
import CurrentUser from "./components/Users/current-user";
import PreciousLbmaLmePrices from "./components/Precious-Lbma-Lme-Prices";
import ChangePassword from "./components/Users/change-password";
import NotFound from "./components/notFound";
import { isNonProductionEnv } from "./settings";
import LazyRoute from "./utils/LazyRoute";
import { LazySimpleProductView } from "./lazyComponents";

const ImportExport = lazy(() => import("./components/Import-Export"));
const SiteMetrics = lazy(() => import("./components/Dashboard/Site Metrics"));
const AWSMetrics = lazy(() => import("./components/Dashboard/AWS"));
const StudioWrapper = lazy(() => import("./components/Shared/StudioWrapper"));
const Screensaver = lazy(() => import("./components/Screensaver"));
const PreciousPricingCalculator = lazy(() => import("./components/Precious-Pricing-Calculator"));
const PriceScraper = lazy(() => import("./components/Price-Scraper"));
const MagicNumberSearch = lazy(() => import("./components/MagicNumberSearch"));

const customRoutes = [
  <Route key="forgot-password" exact path="/forgot-password" component={ForgotPassword} noLayout />,
  <Route
    key="confirm-password"
    exact
    path="/confirm-password"
    component={ConfirmForgotPassword}
    noLayout
  />,
  <Route key="profile" path="/profile" component={CurrentUser} exact />,
  <Route key="change-password" path="/change-password" component={ChangePassword} exact />,
  <Route
    key="bulk-products"
    path="/bulk-products"
    render={(routeProps) => <LazyRoute component={ImportExport} {...routeProps} />}
    exact
  />,
  <Route
    key="sort-order"
    path="/sort-order"
    exact
    render={() => <Redirect to="/ring-material-sort-order" />}
  />,
  <Route
    key="precious-lbma-lme-prices"
    path="/precious-lbma-lme-prices"
    component={isNonProductionEnv ? PreciousLbmaLmePrices : NotFound}
    exact
  />,
  <Route
    key="precious-pricing-calculator"
    path="/precious-pricing-calculator"
    render={(routeProps) => <LazyRoute component={PreciousPricingCalculator} {...routeProps} />}
    exact
  />,
  <Route
    key="screensaver"
    path="/screensaver"
    render={(routeProps) => <LazyRoute component={Screensaver} {...routeProps} />}
    exact
  />,
  <Route
    path="/magic-number-search"
    render={(routeProps) => <LazyRoute component={MagicNumberSearch} {...routeProps} />}
    exact
  />,
  <Route
    key="export-product-price"
    path="/export-product-price"
    render={(routeProps) => <LazyRoute component={PriceScraper} {...routeProps} />}
    exact
  />,
  <Route
    key="dashboard-site"
    path="/dashboard/site"
    render={(routeProps) => <LazyRoute component={SiteMetrics} {...routeProps} />}
    exact
  />,
  <Route
    key="dashboard-application"
    path="/dashboard/application"
    render={(routeProps) => <LazyRoute component={AWSMetrics} {...routeProps} />}
    exact
  />,
  <Route
    key="simple-product-view"
    exact
    path="/simple-products/:id/view"
    render={(routeProps) => (
      <LazyRoute component={LazySimpleProductView} {...routeProps} />
    )}
  />,
  <Route
    key="studio-wrapper"
    path={["/signet-studio", "/design-pattern-studio"]}
    render={(routeProps) => <LazyRoute component={StudioWrapper} {...routeProps} />}
  />,
];

export default customRoutes;
